export enum FormAction {
  add = 'ADD',
  update = 'UPDATE'
}
